import {
  storeUserSession,
  renderApplication,
  redirect,
  storePasswordCriteria,
} from "../SessionManagement/actionCreators"

export const mapState = (state) => ({
  userPool: state.sessionReducer.userPool,
  passwordCriteria: state.sessionReducer.passwordCriteria,
  applicationClientId: state.sessionReducer.applicationClientId,
})

export const mapDispatch = (dispatch) => ({
  redirect: (data) => redirect({ dispatch, ...data }),
  storeUserSession: (info) => dispatch(storeUserSession(info)),
  renderApplication: (data) => dispatch(renderApplication(data)),
  storePasswordCriteria: () => storePasswordCriteria(dispatch),
})
